import type { RouteName } from "../routes.js";

/**
 * Which case the app is looking at outside a session, and which opening the
 * prologue shows.
 *
 * Inside play, the session's own case always wins — a reload must never show
 * another case's opening over the engagement that is actually running. On
 * the PROLOGUE route the learner's explicit choice wins instead: "read the
 * prologue again." on a library card names a case, and until 2026-09-09 the
 * open session's case overrode it, so every card's prologue was the last
 * case played. A reload of the prologue route has no choice in memory and
 * falls back to the session's case, as before.
 */
export function activeCaseSlug(input: {
  readonly route: RouteName;
  readonly chosenSlug: string | null;
  readonly sessionSlug: string | null;
  readonly firstSlug: string | null;
}): string | null {
  const { route, chosenSlug, sessionSlug, firstSlug } = input;
  if (route === "beat") return chosenSlug ?? sessionSlug ?? firstSlug;
  return sessionSlug ?? chosenSlug ?? firstSlug;
}
